import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Router, RouterLink } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';
import { ITodayOffers, ITodayOffers_P, ITodayOffers_S } from '../../interfaces/ITodayOffers';
import { TodayOffersService } from '../../service/today-offers.service';
import { IQueryFormat } from '../../enums/types';
import { ConstantsService } from '../../service/constants.service';
import { NotificationService } from '../../service/notification.service';
import { IAddToCart } from '../../interfaces/IAddToCart';
import { AddToCartService } from '../../service/add-to-cart.service';

@Component({
    selector: 'app-footer',
    standalone: true,
    templateUrl: './footer.html',
    imports: [ReactiveFormsModule, InputTextModule, Tooltip, RouterLink],
    styleUrl: './footer.scss'
})
export class Footer implements OnInit {
    subscript: FormGroup;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    year: number;
    isPopupVisible: boolean = false;
    activeMenu: string = '';
    promoCode: string = '';
    shipping: number = 0;
    cartList: IAddToCart[] = [];
    cartListMap: { [_id: string]: IAddToCart } = {};
    discount: number = 0;
    loading = { form: false };
    todayOffers: ITodayOffers[] = [];

    constructor(private fb: FormBuilder,
                public todayOffersService: TodayOffersService,
                public cs: ConstantsService,
                public addToCartService: AddToCartService,
                public cd: ChangeDetectorRef,
                public ns: NotificationService,
                private router: Router) {
        this.subscript = this.fb.group({
            username: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
        });
        this.year = new Date().getFullYear();
    }

    ngOnInit() {
        window.addEventListener("load", () => {
            setTimeout(() => {
                // @ts-ignore
                document.getElementById("subscribePopup")?.classList.add("show");
            }, 10000);
        });

        const backToTopBtn: any = document.getElementById("backToTop");

        window.addEventListener("scroll", () => {
            if (window.scrollY > 300) {
                backToTopBtn.classList.add("show");
            } else {
                backToTopBtn.classList.remove("show");
            }
        });

        backToTopBtn.addEventListener("click", () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    }

    closePopup() {
        // @ts-ignore
        document.getElementById("subscribePopup").classList.remove("show");
    }



    copyCoupon(code: string) {
        navigator.clipboard.writeText(code);
    }
    get subtotal() {
        return this.cartList.reduce((sum, item) => sum + item.price * item.qty, 0);
    }
    get total() {
        return this.subtotal + this.shipping - this.discount;
    }

    async applyCode() {
        if (!this.promoCode) return;
        if (this.discount > 0) {
            this.loading.form = false;
            return this.ns.showError(this.cs.applyCode.appliedCode);
        }
        try {
            this.loading.form = true;
            let query = <IQueryFormat>{
                find: <ITodayOffers_P>{
                    active: true,
                    tdo_code_str: this.promoCode
                },
                select: <ITodayOffers_S>{
                    tdo_code_str: 1,
                    tdo_product_id_arr: 1,
                    tdo_percentage_offers_num: 1
                },
                limit: 1
            };
            let res = await this.todayOffersService.query(query);
            if (res && res.length) {
                let isExistProductCode = res[0].tdo_product_id_arr.find((e: string) => this.cartListMap[e]);
                if (isExistProductCode) {
                    this.discount = Math.floor(this.total / res[0]?.tdo_percentage_offers_num);
                    this.ns.showSuccess(this.cs.applyCode.success);
                } else {
                    this.ns.showError(this.cs.applyCode.invalidCode);
                }
            } else {
                this.ns.showError(this.cs.applyCode.invalidCode);
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to apply code.');
        }
        this.cd.detectChanges();
    }

    openPrivacyPolicy(menu: string) {
        this.router.navigate(['/privacy-policy']);
        this.activeMenu = menu;
    }
    openAbout(menu: string) {
        this.router.navigate(['/about-us']);
        this.activeMenu = menu;
    }
    openFaq(menu: string) {
        this.router.navigate(['/faqs']);
        this.activeMenu = menu;
    }
    openContact(menu: string) {
        this.router.navigate(['/contact-us']);
        this.activeMenu = menu;
    }

    openTerms(menu: string) {
        this.router.navigate(['/term-and-conditions']);
        this.activeMenu = menu;
    }

}
